import React from 'react';
import BackButton from '../component/BackButton';
import BackgroundMusic from '../component/BackgroundMusic';
import music from '../asset/sound/joan.mp3';
import joan from '../asset/img/joan.png';

function Joan() {
  return (
    <div className="page joan-page">
      <BackButton />
      <div className="joan-container">
        <h1>JOAN POMELO VACHON</h1>
        <h2>September 26th, 2025</h2>
        <p>Come visit us and meet the new baby!</p>
        <img className="joan" src={joan} alt="joan" />
      </div>
      <BackgroundMusic music={music} volume={1} />
    </div>
  );
}

export default Joan;
